import SpellSlot from './SpellSlot';

export default SpellSlot;
